/**
 * chat slice: 채팅 메시지 관리
 * wehago-conference의 redux/modules/chat 에서 리팩토링
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ChatMessage } from '@/types/store';

// re-export for backwards compatibility
export type { ChatMessage } from '@/types/store';

export interface ChatState {
  messages: ChatMessage[];
  unreadCount: number;
  isPanelOpen: boolean;
}

const initialState: ChatState = {
  messages: [],
  unreadCount: 0,
  isPanelOpen: false,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    messageReceived(state, action: PayloadAction<ChatMessage>) {
      // 중복 메시지 방지 (재연결 시 재전송되는 메시지 무시)
      if (state.messages.some((m) => m.id === action.payload.id)) return;
      state.messages.push(action.payload);
      if (!state.isPanelOpen) {
        state.unreadCount += 1;
      }
    },

    setPanelOpen(state, action: PayloadAction<boolean>) {
      state.isPanelOpen = action.payload;
      if (action.payload) {
        state.unreadCount = 0;
      }
    },

    clearUnread(state) {
      state.unreadCount = 0;
    },

    reset() {
      return initialState;
    },
  },
});

export const chatActions = chatSlice.actions;
export default chatSlice.reducer;
